import * as THREE from "three";
import type { CowryTraits } from "../core/types";
import type { PbrTextureSet } from "../textures/textureTypes";

export function buildCowryMaterial(
  traits: CowryTraits,
  textures: PbrTextureSet,
): THREE.MeshPhysicalMaterial {
  return new THREE.MeshPhysicalMaterial({
    name: `cowry-${slug(traits.finishFamily)}-${slug(traits.patternFamily)}`,
    color: 0xffffff,
    map: textures.baseColor.texture,
    roughness: 1,
    roughnessMap: textures.roughness.texture,
    metalness: 1,
    metalnessMap: textures.metalness.texture,
    normalMap: textures.normal.texture,
    // GLTFLoader uses this tangent-less convention; it also avoids exporter-side pixel conversion.
    normalScale: new THREE.Vector2(1, -1),
    clearcoat: traits.pbr.clearcoat,
    clearcoatRoughness: traits.pbr.clearcoatRoughness,
  });
}

function slug(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
}
